export const cDebounce = <F extends (...args: any[]) => void>(
  fn: F,
  delay = 300
) => {
  let timer: ReturnType<typeof setTimeout>;

  return (...args: Parameters<F>) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};
